import { useQueryClient } from '@tanstack/react-query';
import produce from 'immer';
import { useAuthStateStore } from '@annunciate/core';
import { TAG_DELETE } from '@annunciate/query/dist/queries/tag';
import { useMutation } from './base';
const getUUID = useAuthStateStore.getState().getUUID;
export const useTagDeleteMutation = () => {
    const client = useQueryClient();
    return useMutation(TAG_DELETE, {
        onSuccess: (data) => {
            const tag = data;
            const uuid = getUUID(true);
            const key = ['tag', uuid];
            client.setQueryData(key, (old) => {
                return produce(old || [], (draft) => {
                    const idx = draft.findIndex((t) => t.id === tag.id);
                    if (idx > -1) {
                        draft.splice(idx, 1);
                    }
                });
            });
        },
    }, (data) => data.tag);
};
//# sourceMappingURL=useTagDeleteMutation.js.map